// @flow

import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

const query = gql`
  query mapPoints(
    $storyFilter: NodeQueryFilterInput!
    $eventFilter: NodeQueryFilterInput!
  ) {
    stories: nodeQuery(filter: $storyFilter) {
      entities {
        entityLabel
        fieldSubtitle
        fieldShortDescription
        fieldThemeColor
        fieldLocation
        fieldImage3
        entityUrl {
          alias
        }
      }
    }
    events: nodeQuery(filter: $eventFilter) {
      entities {
        entityLabel
        fieldDate
        fieldImage
        fieldLocation
        body
      }
    }
  }
`;

type MapQueryProps = {
  stories: PropTypes.any.isRequired,
  events: PropTypes.any.isRequired,
};

const MapQuery = graphql(query, {
  options: () => ({
    variables: {
      storyFilter: {
        type: 'story',
        status: true,
      },
      eventFilter: {
        type: 'event',
        status: true,
      },
    },
  }),
  props: ({ data: { stories, events } }: any): MapQueryProps => ({
    stories,
    events,
  }),
});

export default MapQuery;



// WEBPACK FOOTER //
// ./screens/App/screens/GMap/MapQuery.js